import React, { Component } from 'react';
import MdPerson from 'react-ionicons/lib/MdPerson';
import MdClose from 'react-ionicons/lib/MdClose';
import MdInformationCircle from 'react-ionicons/lib/MdInformationCircle';
import withUser from './withUser';
import Authentication from './Authentication';
import Modal from 'react-modal';
import { Scrollbars } from 'react-custom-scrollbars';

class Header extends Component {
  state={
    showModal: false
  }

  _openModal = (index) => {
    this.setState({
      showModal: true
    });
  }
  openModal = this._openModal.bind(this);

  _closeModal = () => {
    this.setState({
      showModal: false
    });
  }
  closeModal = this._closeModal.bind(this);


  render() {
    const { user, leaveBar } = this.props;
    const { showModal } = this.state;
    return (
      <header className = "bh-header">
        <div className="bh-header__brand"><h4>banhopper</h4><MdInformationCircle onClick={this.openModal} fontSize="18px"/></div>
        <Authentication />
        <Modal
          className="bh-modal"
          ariaHideApp={false}
          isOpen={showModal} >
          <div className="bh-modal__header">
            <h6>About</h6>
            <MdClose
              className = "urb-icon urb-icon--sm"
              onClick = {this.closeModal} />
          </div>

            <Scrollbars style={{ height: (400) }}>
            <div className="bh-modal__content">
              <h5>
                banhopper is a web app allowing people to support their favorite bars, restaurants and eateries during lockdown.
              </h5>
              <h6>Is this for real?</h6>
              <p>
                Not yet.
                This is a prototype built for a hackathon. The featured bars are included only as placeholders,
                and you cannot support them - yet. All images and texts are from the glorious internet. If you want me to edit
                or remove anything, get in touch at katerina.vsv@gmail.com.
              </p>
              <h6>Why?</h6>
              <p>
                Many small venues are in lockdown, and no one knows how long this is going to last.
                They're already losing a lot, and there's currently no guarantee that the state will back them up.
                This is an attempt to think about alternative forms of solidarity to preserve the places we love.
              </p>
              <h6>How would it work?</h6>
              <p>
                The current idea - and mind you, I'm not an economist, so if you have a better one, let me know - is to
                let users "buy" drinks online and receive credits for future use.
                Each venue should be free to decide - transparently, of course - how those credits would be used:
                could be free drinks, discounts, promotions, access to events, or anything else.
              </p>
              <h6>What are the next steps?</h6>
              <p>
                OH, DREAMS ARE BIG.
                But seriously, as a next step I'd like to hear from venue owners, managers and anyone else
                what they think is most necessary at the moment. Technologically, a lot of things are possible.
                Socially and economically, not everything makes sense. Help me out, and get in touch at katerina.vsv@gmail.com.
                Or hello@zeroattentionspan.net, if you wanna keep it professional.

              </p>
              <h6>P.S.</h6>
              <p>Cheers to Boris Mihov for the UX support - see you in belot.bg.</p>
            </div>
            </Scrollbars>

        </Modal>
      </header>
    )
  }

}


const LayoutSide = ({ user, leaveBar, children }) => {
  return (
   <div className="bh-layout bh-layout--left">
    <Header user={user} leaveBar={leaveBar}/>
    <div className="bh-layout--side___content">
      { children }
    </div>
   </div>
  )
}

export default withUser(LayoutSide);
